export default "__VITE_ASSET__BSTh67m6__"